import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  image = "/assets/img/logo-circle-light.svg",
  url = "https://araria.com.br",
}) => {
  const { t } = useTranslation();
  const defaultTitle = "Araria - Todos os Modelos Premium de IA em um Só Lugar";
  const defaultDescription = t("home.hero.subtitle");
  const defaultKeywords =
    "IA, ChatGPT, Claude, Gemini, Mistral, Groq, MidJourney, inteligência artificial, chat, geração de imagens, geração de vídeos, IA Brasil";

  return (
    <Helmet>
      <title>{title ? `${title} | Araria` : defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title || defaultTitle} />
      <meta
        property="twitter:description"
        content={description || defaultDescription}
      />
      <meta property="twitter:image" content={image} />

      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="pt-BR" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};
